import React, { Component } from "react";
import { connect } from "react-redux";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { ComponentHeader, InformationModal, VerifiedModal } from "../common";
import { deleteRolsApi, getAllRolesApi } from "./Api";
import editIcon from "../../assets/images/edit-icon.svg";
import deleteIcon from "../../assets/images/delete-icon.svg";
import { Col, Image, Row } from "react-bootstrap";
import { MODULE_ID_MAP, START_PAGE, isModuleExist } from "../../utils/Constant";
import editPencil from "../../assets/images/edit-icon.png";
import { USER_ROLE_VERIFY } from "../../utils/urls";
import FilterVefiedDropDown from "../common/FilterVefiedDropDown";
import { withRouter } from "../../utils/hoc/withRouter";
import { Tag } from "antd";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";

class Roles extends Component {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.RoleUserRole);

    this.state = {
      access: AccesData,
      delete: false,
      deleteData: {},

      isVerify: false,
      show: false,
      verified: "",
      verifyUrl: "",
    };
  }

  componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getAllRolesApi(this);
  }
  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";
    const prevSearch = prevParams.get("search") || "";
    const prevSize = prevParams.get("pageSize") || "";

    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const verified = params.get("isVerified") || "";
    const search = params.get("search") || "";
    const size = params.get("pageSize") || "";

    if (
      prevPage !== page ||
      prevVerified !== verified ||
      prevSearch !== search ||
      prevSize !== size
    ) {
      this.setState({ currentPage: page }, () => {
        this.props.getAllRolesApi(this);
      });
    }
  }
  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };
  deleteHandle = async (id) => {
    deleteRolsApi(id, this, this.openCloseDeleteModal);
  };
  render() {
    const { access } = this.state;
    const { roleList, totalPages, currentPage } = this.props.rolesState;

    return (
      <>
        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.role.uuid}
            title={`Are you sure you want to delete ${this.state.deleteData.role?.roleName} ?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}
        <VerifiedModal
          name={`'${this.state.editData?.roleName}'`}
          show={this.state.show}
          url={USER_ROLE_VERIFY + `/${this.state?.editData?.uuid}`}
          isVerified={this.state.isVerify}
          handleCancel={() => {
            this.setState({ show: false });
          }}
          successRes={() => {
            this.props.getAllRolesApi(this);
          }}
        />
        <section className="request-section">
          <ComponentHeader
            title="Roles"
            breadcrumb={[
              ["Roles", ""],
              ["User Roles", ""],
            ]}
            primaryBtn={access.createAccess ? "Add Role" : ""}
            handlePrimaryBtn={() => {
              this.props.history({
                pathname: "/add-role",
                state: { roleList },
              });
            }}
            ctx={this}
          />
          <Row>
            <Col sm={2}>
              <FilterVefiedDropDown ctx={this} />
            </Col>
          </Row>
          <div className="commom-table-wrapper">
            <CustomTable
              ctx={this}
              data={roleList?.list || []}
              columns={[
                {
                  width: 250,
                  title: "Role",
                  dataIndex: "role",
                  className: "name",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    return rowData?.role?.roleName;
                  },
                },
                {
                  width: access.verificationAccess ? 110 : 0,
                  title: "Verified",
                  dataIndex: "isVerified",
                  className: "name",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    const color = rowData.isVerified ? "green" : "orange";
                    return (
                      <div className=" d-flex align-items-center inter-medium">
                        <Tag color={color}>
                          {rowData.isVerified ? "YES" : "NO"}
                          <Image
                            src={editPencil}
                            onClick={() =>
                              this.setState({
                                show: true,
                                isVerify: rowData.isVerified,
                                editData: {
                                  uuid: rowData.role?.uuid,
                                  roleName: rowData.role?.roleName,
                                },
                              })
                            }
                            className="edit-pencil-icon"
                            alt="icon"
                          />
                        </Tag>
                      </div>
                    );
                  },
                },
                {
                  width: 250,
                  title: "Role Type",
                  dataIndex: "roleType",
                  className: "name",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    return rowData?.role?.roleType || "Na";
                  },
                },
                {
                  width: 150,
                  title: "Updated By",
                  dataIndex: "updatedBy",
                  className: "name",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    return rowData.role?.updatedBy?.name || "Na";
                  },
                },
                {
                  width: 150,
                  title: "Created By",
                  dataIndex: "createdBy",
                  className: "name",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    return rowData.role?.createdBy?.name || "Na";
                  },
                },
                {
                  // width: 170,
                  width: 20,
                  title: "Action",
                  dataIndex: "",
                  className: "",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    return (
                      <>
                        <OptionsDropdown
                          editHandler={
                            access?.updateAccess
                              ? () => {
                                  this.props.history({
                                    pathname: "/edit-role",
                                    state: { roleList, editData: rowData },
                                  });
                                }
                              : null
                          }
                          deleteHandler={
                            access?.deleteAccess
                              ? () => {
                                  this.openCloseDeleteModal(rowData);
                                }
                              : null
                          }
                        />
                      </>
                    );
                  },
                },
              ]}
              total={roleList?.length || 0}
              loading={this.state.isLoading}
            />
          </div>
        </section>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  rolesState: state.RolesState,
});
const mapDispatchToProps = {
  getAllRolesApi,
};
Roles.propTypes = {
  // getPosts: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Roles));
